export default __webpack_public_path__ + "static/media/OPD_CARD_COVER_V1.3f4d3c8f.png";